// GERADO de backend-senne/src/contracts — NÃO editar; rode scripts/sync-contracts.sh

import { z } from 'zod'

/**
 * GET /users/doctors?crm=&uf= (spec 20261026-142400, D1): the doctor registry of the core, in the shape the screens
 * already read (portal-senneliquor `doctorsRepository.getByCrm`, portal-senne-exames `ApproveDoctor`). `doctorId` is
 * the registry id; `doctorCRM` holds the digits with no leading zero.
 */
/** The query: both required, no coercion (a missing value must not become the string "undefined"). */
export const doctorRegistryQuerySchema = z.object({
    crm: z.string().trim().min(1, 'CRM é obrigatório'),
    uf: z.string().trim().length(2, 'UF deve ter 2 caracteres'),
})
export type DoctorRegistryQuery = z.infer<typeof doctorRegistryQuerySchema>

export const doctorRegistryRowSchema = z
    .object({
        doctorId: z.number().int().positive(),
        doctorName: z.string(),
        doctorCRM: z.string(),
        doctorUF: z.string().length(2),
    })
    .strict()
export type DoctorRegistryRow = z.infer<typeof doctorRegistryRowSchema>

export const doctorLookupResponseSchema = z.object({
    message: z.string(),
    doctors: z.object({
        total_itens: z.number().int().nonnegative(),
        rows: z.array(doctorRegistryRowSchema),
    }),
})
export type DoctorLookupResponse = z.infer<typeof doctorLookupResponseSchema>
